const promptControlViewType = {
  TEXTAREA: "TEXTAREA",
  TEMPLATES: "TEMPLATES",
};

export default promptControlViewType;
